'use strict';

exports = module.exports = {
    // List of user roles
    userRoles: ['guest', 'user', 'admin'],
    cloudinary: {
        cloud_name: 'dcjcodcql',
        api_key: '128428673699392',
        api_secret: 'vCuyovufE4pdI4iZHt2NHhKrWyQ'
    },
    // cloudinary: { //cuenta de martin (mia)
    //     cloud_name: 'dezsjisey',
    //     api_key: '548859556433139',
    //     api_secret: '5Pr-Jh7aXCdTGrgjQEWV81dPkwQ'
    // },
    sendGridApi: {
        KEY: 'YJQ5jVjMRFSJUBMYWg_t5g',
        SECRET: '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'
    }
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 90
// module chunks = 0